import {isFeatureEnabled} from 'feature-flags';
import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import {RequestVehicle} from '../../../types/api/api';
import {featureFlags} from '../../../utils/featureFlags';
import {WITHOUT_VAT} from '../constants/withoutVAT';
import {WITH_VAT} from '../constants/withVAT';
import {VehicleFormType} from '../types/VehicleFormType';

const convertDoorCount = (doorCount: string): string =>
  match(doorCount)
    .with('DOORCOUNT_2', () => 'DOORCOUNT_2_3')
    .with('DOORCOUNT_3', () => 'DOORCOUNT_2_3')
    .with('DOORCOUNT_4', () => 'DOORCOUNT_4_5')
    .with('DOORCOUNT_5', () => 'DOORCOUNT_4_5')
    .with('DOORCOUNT_6', () => 'DOORCOUNT_6_7')
    .with('DOORCOUNT_7', () => 'DOORCOUNT_6_7')
    .otherwise(() => doorCount);

export const getDefaultValues = (vehicle: RequestVehicle | Nullish): Partial<VehicleFormType> => ({
  bodyStyle: vehicle?.bodyStyle ? [vehicle.bodyStyle] : undefined,
  drive: vehicle?.drive ? [vehicle.drive] : undefined,
  features: vehicle?.features?.filter(isNotNil) ?? [],
  firstRegistrationOnYear: vehicle?.firstRegistrationOnYear ?? undefined,
  fuelType: vehicle?.fuelType ? [vehicle.fuelType] : undefined,
  isVatDeductible: match<boolean | Nullish, [string] | undefined>(vehicle?.isVatDeductible)
    .with(true, () => [WITH_VAT])
    .with(false, () => [WITHOUT_VAT])
    .otherwise(() => undefined),
  make: vehicle?.make ?? undefined,
  modelFamily: vehicle?.modelFamily ?? undefined,
  trimLevel: vehicle?.trimLevel ?? undefined,
  mileage: vehicle?.mileage ?? undefined,
  power: isFeatureEnabled(featureFlags.PR_SPLIT_POWER)
    ? (vehicle?.power ?? undefined)
    : (vehicle?.maxPower ?? vehicle?.power ?? undefined),
  maxPower: isFeatureEnabled(featureFlags.PR_SPLIT_POWER)
    ? (vehicle?.maxPower ?? undefined)
    : undefined,
  transmission: vehicle?.transmission ? [vehicle.transmission] : undefined,
  vin: vehicle?.vin ?? undefined,
  exteriorColor: vehicle?.exteriorColor ? [vehicle.exteriorColor] : undefined,
  doorCount: vehicle?.doorCountCategory ? [convertDoorCount(vehicle.doorCountCategory)] : undefined,
  seatCount: isNotNil(vehicle?.seatCount) ? [`${vehicle?.seatCount ?? ''}`] : undefined,
  interiorMaterial: vehicle?.interiorMaterial ? [vehicle.interiorMaterial] : undefined,
});
